var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0556 6.79175H12C10.8954 6.79175 10 7.68718 10 8.79175V50.0695C10 51.1741 10.8954 52.0695 12 52.0695H44.2222C45.3268 52.0695 46.2222 51.1741 46.2222 50.0695V8.79175C46.2222 7.68718 45.3268 6.79175 44.2222 6.79175H37.1667V7.92369C37.1667 9.79916 35.6463 11.3195 33.7708 11.3195H22.4514C20.5759 11.3195 19.0556 9.79916 19.0556 7.92369V6.79175Z",
    fill: "#8A94A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3749 4.5278L34.4027 4.52781C34.6788 4.52781 34.9027 4.75166 34.9027 5.02781V8.55558C34.9027 8.83172 34.6788 9.05558 34.4027 9.05558H21.8193C21.5432 9.05558 21.3193 8.83173 21.3193 8.55558V5.02781C21.3193 4.75166 21.5432 4.52781 21.8193 4.52781L25.8471 4.5278C25.8471 3.27749 26.8607 2.26392 28.111 2.26392C29.3613 2.26392 30.3749 3.27749 30.3749 4.5278Z",
    fill: "#8A94A6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.7915,
    y: 22.6389,
    width: 11.3194,
    height: 4.52778,
    rx: 2,
    fill: "#8A94A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.7915,
    y: 31.6943,
    width: 20.375,
    height: 4.52778,
    rx: 2,
    fill: "#8A94A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/Sales.5c67a2f9fc2cdd097b9d5a0597720a82.svg";
export { ForwardRef as ReactComponent };